import Card from '../Reusable/Card';
//@ts-ignore
import { tw } from '@careinfo/tailwind';

export default function Cards({ data, isLoading, totalTicketCount }) {
  return (
    <div className={tw`grid grid-cols-5 gap-4`}>
      {isLoading ? (
        Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className={tw`w-50  bg-gray-200 h-14 rounded-md animate-pulse mb-8`}
            style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
          ></div>
        ))
      ) : (
        <>
          <Card title={'Total Tickets'}>
            <p className={tw`mt-auto h-full`}>{totalTicketCount}</p>
          </Card>
          {data.map((d, i) => (
            <Card key={d?.id} title={d?.label}>
              <p className={tw`mt-auto h-full`}>{d?.value}</p>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}
